import { buildCommercialApprovalHtml } from './buildCommercialApprovalHtml';
import type { CommercialApprovalData } from './types';

export function exportCommercialApprovalHtml(data: CommercialApprovalData): void {
  const html = buildCommercialApprovalHtml(data);
  const blob = new Blob([html], { type: 'text/html;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const dateSlug = new Date()
    .toLocaleDateString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' })
    .replace(/\//g, '-');
  const link = document.createElement('a');
  link.href = url;
  link.download = `Commercial Approval - ${data.propertyName.replace(/[^a-zA-Z0-9_\- ]/g, '')} - ${dateSlug}.html`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
